<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body p-10 pb-24">
        <div class="mb-24">
          <div class="flex flex-row gap-5">
            <div class="border-1 w-full border border-solid rounded-lg p-5">
              <h5>{{ $t("Payer") }}</h5>
              <div class="mt-5">
                <label class="vs-select--label">{{ $t("Account") }}</label>
                <v-select
                  label="name"
                  :options="listOfAccountPayer"
                  name="account"
                  v-model="model.payerAccount"
                  @input="onlistOfAccountPayerSelected"
                  :clearable="false"
                  dir="rtl"
                >
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('account')"
                  >{{ errors.first("account") }}</span
                >
              </div>
              <div class="mt-5">
                <label class="vs-select--label">{{
                  $t("AccountFloating")
                }}</label>
                <v-select
                  label="name"
                  :options="listOfFloatingAccountPayer"
                  name="floatingAccount"
                  v-model="model.payerFloatingAccount"
                  :clearable="true"
                  :loading="searchFlag"
                  dir="rtl"
                >
                </v-select>
              </div>

            </div>
            <div class="border-1 w-full border border-solid rounded-lg p-5">
              <h5>{{ $t("Receiver") }}</h5>
              <div class="mt-5">
                <label class="vs-select--label">{{ $t("Account") }}</label>
                <v-select
                  label="name"
                  :options="listOfAccount"
                  name="account"
                  v-model="model.receiverAccount"
                  @input="onlistOfAccountSelected"
                  :clearable="false"
                  dir="rtl"
                >
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('account')"
                  >{{ errors.first("account") }}</span
                >
              </div>
              <div class="mt-5">
                <label class="vs-select--label">{{
                  $t("AccountFloating")
                }}</label>
                <v-select
                  label="name"
                  :options="listOfFloatingAccount"
                  name="floatingAccount"
                  v-model="model.receiverFloatingAccount"
                  :loading="searchFlagReceiver"
                  :clearable="true"
                  dir="rtl"
                >
                </v-select>
              </div>

            </div>
          </div>
          <div class="flex flex-row gap-5">
            <div class="w-1/2">
              <vs-input
                class="inputx mb-4 mt-5"
                v-model="price"
                name="bPrice"
                :label="$t('Fee')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('bPrice')">{{
                errors.first("bPrice")
              }}</span>
            </div>
            <div class="w-1/2 mt-5">
              <label class="vs-select--label datepicker-lb">{{
                $t("CreateOn")
              }}</label>
              <date-picker
                v-model="model.createOn"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                v-validate="'required'"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                id="date-picker"
                :label="$t('CreateOn')"
                name="date"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('CreateOn')"
                >{{ errors.first("CreateOn") }}</span
              >
            </div>
          </div>

          <div>
            <vs-textarea
              rows="3"
              class="mt-4"
              name="Description"
              :label="$t('Description')"
              v-validate="'required'"
              v-model="model.description"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Description')"
              >{{ errors.first("Description") }}</span
            >
          </div>
          <vs-button
          type="filled"
          class="float-right mt-4"
          :class="model.id != null ? 'mt-12' : ''"
          @click.prevent="submitForm"
          :disabled="
            !model.description ||
            !model.createOn ||
            !price ||
            !model.payerAccount ||
            !model.receiverAccount 
          "
          >{{ $t("Save") }}</vs-button
        >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "@/components/CustomVSelect.vue";

const dict = {
  custom: {
    CreateOn: {
      required: "لطفا تاریخ درج را وارد نمایید.",
    },
    account: {
      required: "لطفا  حساب را وارد نمایید.",
    },
    bPrice: {
      required: "لطفا  مبلغ را وارد نمایید.",
    },
    Description: {
      required: "لطفا  توضیحات را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  components: {
    "v-select": vSelect,
  },

  data() {
    return {
      price: null,
      listOfAccount: [],
      listOfAccountPayer: [],
      listOfFloatingAccount: [],
      listOfFloatingAccountPayer: [],
      model: {},
      disabled: false,
      searchFlag:false,
      searchFlagReceiver:false,

    };
  },
  mounted() {
    this.GetData();
  },

  methods: {
    ...mapActions({
      fetchAccounts: "subsidiaryAccount/fetchSubsidiary",
      fetchFloatingAccounts: "pettyCash/getAllLastLevelOfFloatingAccounts",
      createAccount: "pettyCash/saveChargePettyCash",
    }),
    GetData() {
      this.fetchAccounts().then((result) => {
        result.forEach((element) => {
          var x = {
            id: element.id,
            name: element.title,
            code: element.code,
          };
          this.listOfAccount.push(x);
          this.listOfAccountPayer.push(x);
        });
      });
    },

    onlistOfAccountSelected() {
      this.searchFlagReceiver=true
      this.listOfFloatingAccount = [];
      if(this.model.receiverFloatingAccount){
        this.model.receiverFloatingAccount=null;
      }
      this.fetchFloatingAccounts(this.model.receiverAccount.id).then(
        (result) => {
          this.searchFlagReceiver=false

          result.forEach((element) => {
            var x = {
              id: element.id,
              name: element.title,
              code: element.code,
            };
            this.listOfFloatingAccount.push(x);
          });
        }
      );
    },
    onlistOfAccountPayerSelected() {
      this.searchFlag=true;

      this.listOfFloatingAccountPayer = [];
      if(this.model.payerFloatingAccount){
        this.model.payerFloatingAccount=null;
      }

      this.fetchFloatingAccounts(this.model.payerAccount.id).then((result) => {
        this.searchFlag=false;

        result.forEach((element) => {
          var x = {
            id: element.id,
            name: element.title,
            code: element.code,
          };
          this.listOfFloatingAccountPayer.push(x);
        });
      });
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.disabled = true;
        if (result) {
          var payload = {
            amount: this.model.amount,
            createOn: this.model.createOn,
            description: this.model.description,
            payerInfo: {
              accountId: this.model.payerAccount.id,
              floatingAccountId: this.model.payerFloatingAccount
                ? this.model.payerFloatingAccount.id
                : null,
  
            },
            receiverInfo: {
              accountId: this.model.receiverAccount.id,
              floatingAccountId: this.model.receiverFloatingAccount
                ? this.model.receiverFloatingAccount.id
                : null,

            },
          };
          this.createAccount(payload).then(() => {
            this.$router.go(-1);
            this.model = {};
            this.$validator.reset();
            this.disabled = false;
          });
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    price(value) {
      if (value) {
        var n = parseFloat(value.replace(/,/g, ""), 10);
        this.price = n.toLocaleString();
        this.model.amount = this.price.replace(/,/g, "");
      } else {
        this.price = null;
        this.model.amount = null;
      }
    },
  },
};
</script>
